import { geoTypeLabel } from '@/Enums/Geography/GeographyType.enum';
import Clear from '@mui/icons-material/Clear';
import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { GREY, PRIMARY } from '../../../constants/color';

const SelectedLocationChip = memo(({ locationName, locationType, onRemove }) => {
  return (
    <div className='flex items-center gap-2 px-3 py-1 border rounded-full border-[#DADADA]'>
      <span className={`text-[${PRIMARY}] text-[14px] font-semibold`}>{locationName}</span>
      <span className={`text-[${GREY}] text-[12px]`}>{geoTypeLabel(locationType)}</span>
      <IconButton sx={{ fill: GREY, padding: 0 }} onClick={onRemove}>
        <Clear sx={{ width: '16px', height: '16px' }} />
      </IconButton>
    </div>
  );
});

SelectedLocationChip.propTypes = {
  locationName: PropTypes.string,
  locationType: PropTypes.string,
  onRemove: PropTypes.func,
};

export default SelectedLocationChip;
